export { default } from "./ProseMirrorLinkMark";
